import React, { useEffect, useState } from 'react';
import { func, string } from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';

import { FieldTextInput, Form, H1, H4, H5, PrimaryButton } from '../..';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { priceData } from '../../../containers/ListingPage/ListingPage.shared';
import { types as sdkTypes } from '../../../util/sdkLoader';

import css from './StudentForm.module.css';
import { PRICE_ZERO } from '../../../util/types';

const { Money } = sdkTypes;

const renderForm = formRenderProps => {
    // FormRenderProps from final-form
    const {
        formId,
        className,
        rootClassName,
        handleSubmit,
        form,
        values,
        intl,
        pricePerLanguageOptions = [],
        marketplaceCurrency,
        invalid,
        listing
    } = formRenderProps;

    useEffect(() =>{
        const listingId = (listing?.id?.uuid) || null;
        const listingTitle = (listing && listing.id && listing.attributes.title) || null; 
        form.batch(() =>{
            form.change('listingId', listingId);
            form.change('listingTitle', listingTitle);
        })
    }, [listing]);

    const classes = classNames(rootClassName || css.root, className);
    const [customError, setCustomError] = useState({ service: false });
    const animatedComponents = makeAnimated();
    const releventServiceOptions = (Array.isArray(pricePerLanguageOptions) && pricePerLanguageOptions.length && pricePerLanguageOptions.map(item => {
        const { formattedPrice } = priceData(new Money(item.price, marketplaceCurrency), marketplaceCurrency, intl);
        const label = intl.formatMessage({ id: "BookingTimeForm.serviceOptionsLabel" }, { label: item.label, price: formattedPrice == PRICE_ZERO ? intl.formatMessage({ id: "BookingTimeForm.freeColsuntationFees" }) : intl.formatMessage({ id: "BookingTimeForm.pricetext" }, { price: formattedPrice }) });
        return { label: label, option: item.price };
    })) || [];

    const submitDisabled = !(Object.keys(values).length && Object.hasOwn(values, 'service'));

    return (
        <Form id={formId} onSubmit={handleSubmit} className={classes}>
            <div className={css.formContainer}>
                <div className={css.inputBox}>
                    <label>{intl.formatMessage({ id: "StudentForm.ReferServiceLabel" })}</label>
                    <Select
                        closeMenuOnSelect={true}
                        className={css.multiSelect}
                        classNames={{
                            option: (state) => (state?.data?.label == (values?.service && JSON.parse(values?.service).label) ? css.selectedOption : css.notSelectedOption),
                        }}
                        components={animatedComponents}
                        isMulti={false}
                        value={releventServiceOptions.find(option => option.label == (values?.service && JSON.parse(values?.service).label))}
                        options={releventServiceOptions}
                        placeholder={intl.formatMessage({ id: "BookingTimeForm.SelectOneLabel" })}
                        isSearchable={false}
                        onChange={value => {
                            form.change('service', JSON.stringify(value));
                        }}
                        onFocus={() => setCustomError(prev => ({ ...prev, service: false }))}
                        onBlur={() => values.service == undefined && setCustomError(prev => ({ ...prev, service: true }))}
                    />
                    {customError.service ?
                        <p className={css.customError}>{intl.formatMessage({ id: "UniversalRequiredMessage.MessageText" }, { fieldName: "This Field" })}</p>
                        : null}
                </div>

                {/* Note to student */}
                <FieldTextInput
                    id={"message"}
                    name={"message"}
                    type={"textarea"}
                    label={intl.formatMessage({ id: "StudentForm.noteToStudentLabel" })}
                    placeholder={intl.formatMessage({ id: "StudentForm.noteToStudentPlaceHolder" })}
                />

                <PrimaryButton type="submit" className={css.submitButton} disabled={submitDisabled}>
                    <FormattedMessage id="StudentForm.SubmitButton" />
                </PrimaryButton>
            </div>
        </Form>
    );
};

const StudentBookingForm = props => {
    const intl = useIntl();
    const initialValues = {};

    return <FinalForm initialValues={initialValues} {...props} intl={intl} render={renderForm} />;
};

StudentBookingForm.defaultProps = {
    rootClassName: null,
    className: null,
};

StudentBookingForm.propTypes = {
    rootClassName: string,
    className: string,

    // form
    formId: string.isRequired,
    onSubmit: func.isRequired,
};

export default StudentBookingForm;